<template>

  <div>

    <div class="product__buy-button-container clearfix">

      <a href="#"
      @click.prevent="toggleLinks"
      class="product__buy-button"
      >
        <i :class="buyButtonIcon"></i>
        Comprar

      </a>

    </div>

    <div v-show="showLinks">

      <p>
        <i class="fas fa-info-circle product__buy-text-icon"></i>
        Este produto está disponível para venda {{marketplaces.length === 1 ? 'na loja' : 'nas lojas'}} abaixo:
      </p>

      <a
              v-for="marketplace in marketplaces"
              :href="marketplace.url"
              target="_blank"
              class="product__buy-button-link"
      >
        <img :src="marketplace.logo" :alt="marketplace.name" class="img-fluid">
      </a>

    </div>

  </div>

</template>

<script>

export default {

  props: ['marketplaces'],

  data(){

    return {
      showLinks: false
    }

  },

  methods: {

    toggleLinks(){
      this.showLinks = !this.showLinks;
    }

  },

  computed: {

    buyButtonIcon(){
      return this.showLinks ? 'fas fa-chevron-up' : 'fas fa-chevron-down';
    }

  }

};

</script>
